import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaMapMarkerAlt } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { Link } from "react-router-dom";

import "./css/BestTourPackages.css";

const BestTourPackages = () => {

const trips = [
  {
    title: "Kathmandu Spiritual Tour",
    img: "/Images/tour/kathmandu-banner.avif",
    location: "Nepal",
    duration: "3 Days / 4 Nights",
    date: "01 May, 08 May",
    price: "₹18,999",
    link: "/kathmandu",
  },
  {
    title: "Pokhara Scenic Escape",
    img: "/Images/tour/pokhara-banner.jpg",
    location: "Nepal",
    duration: "3 Days / 4 Nights",
    date: "07 May, 14 May",
    price: "₹21,999",
    link: "/pokhara",
  },
  {
    title: "Manokamna Darshan",
    img: "/Images/tour/manokamna1.jpg",
    location: "Nepal",
    duration: "2 Days / 3 Nights",
    date: "05 May, 12 May",
    price: "₹15,999",
    link: "/manokamna",
  },
  {
    title: "Lumbini Buddhist Tour",
    img: "/Images/tour/Lumbini.jpg",
    location: "Nepal",
    duration: "2 Days / 3 Nights",
    date: "09 May, 16 May",
    price: "₹16,999",
    link: "/lumbini",
  },
  {
    title: "Muktinath Darshan",
    img: "/Images/tour/Muktinath.jpg",
    location: "Nepal",
    duration: "5 Days / 6 Nights",
    date: "02 May, 09 May",
    price: "₹34,999",
    link: "/muktinath",
  },
  {
    title: "Chitwan Jungle Safari",
    img: "/Images/tour/Chitwan.jpg",
    location: "Nepal",
    duration: "3 Days / 4 Nights",
    date: "11 May, 18 May",
    price: "₹19,999",
    link: "/chitwan",
  },
  {
    title: "Janakpur Religious Tour",
    img: "/Images/tour/Janakpur.jpg",
    location: "Nepal",
    duration: "2 Days / 3 Nights",
    date: "06 May, 13 May",
    price: "₹14,999",
    link: "/janakpur",
  },
  {
    title: "Varanasi Spiritual Tour",
    img: "/Images/tour/Varanasi.webp",
    location: "India",
    duration: "2 Days / 3 Nights",
    date: "05 May, 12 May",
    price: "₹14,999",
    link: "/varanasi",
  },
  {
    title: "Ayodhya Ram Mandir Tour",
    img: "/Images/tour/Ayodhya.webp",
    location: "India",
    duration: "2 Days / 3 Nights",
    date: "08 May, 15 May",
    price: "₹13,999",
    link: "/ayodhya-tour-package",
  },
  {
    title: "Kushinagar Buddhist Circuit",
    img: "/Images/tour/Kushinagar.jpg",
    location: "India",
    duration: "2 Days / 3 Nights",
    date: "10 May, 17 May",
    price: "₹12,999",
    link: "/kushinagar",
  },
  {
    title: "Darjeeling Hill Retreat",
    img: "/Images/tour/darjeeling.jpeg",
    location: "India",
    duration: "4 Days / 5 Nights",
    date: "03 May, 10 May",
    price: "₹24,999",
    link: "/darjeeling",
  },
  {
    title: "Sikkim Himalayan Tour",
    img: "/Images/tour/Sikkim.jpg",
    location: "India",
    duration: "5 Days / 6 Nights",
    date: "12 May, 19 May",
    price: "₹29,999",
    link: "/sikkim",
  },
];

  return (
    <section className="upcoming-section">
      <Container>

        <div className="section-header text-center mb-5">
          <h2>Best Tour Packages 2026 / 2027</h2>
        </div>

        <Row>
          {trips.map((trip, index) => (
            <Col lg={3} md={4} sm={6} xs={12} key={index} className="mb-4">

              <div className="trip-card">

                {/* IMAGE */}
                <div className="trip-image">
                  <img src={trip.img} alt={trip.title} />

                  <span className="trip-tag">Group Tour</span>

                  {/* <div className="trip-duration">
                    ⏱ {trip.duration}
                  </div> */}
                </div>

                {/* CONTENT */}
                <div className="trip-content-bestTour">

                  <h4>{trip.title}</h4>

                  <p className="location">
                    <FaMapMarkerAlt /> {trip.location}
                  </p>

                  {/* <p className="date">{trip.date}</p> */}

                  <div className="trip-footer">

                    <h5>{trip.price}<span>/per</span></h5>

                    <div className="trip-buttons">

                        <a
                        href="https://wa.me/919919222273 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="call-btn"
                        >
                        <IoLogoWhatsapp />
                        </a>

                      <Link to={trip.link} className="details-btn">
                        More Details
                      </Link>

                    </div>

                  </div>

                </div>

              </div>

            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default BestTourPackages;